import React, { useMemo } from 'react';

function BlogSearchResult({ blogs, areBlogListLoading }) {
    const noSearchResults = useMemo(
        () => (
            <>
                <h3 className="font-medium text-gray-500 py-6 md:py-20 flex justify-center">
                    No Blog Article Found
                </h3>
            </>
        ),
        [blogs]
    );

    return <>{!areBlogListLoading && !blogs?.length && noSearchResults}</>;
}

export default BlogSearchResult;
